export default __webpack_public_path__ + "static/media/OmaduroDoubleToro.7f275b95.png";